<div>
	<div class="success-graphic">
		<img src="assets/image/submit-success-dialog.png" alt="" />
		<div>
			{{ "success.thankYou" | translate }}
		</div>
	</div>
	<div class="success-content">
		<span *ngIf="onOperation">
			{{
			"success.quotationsProcessed"
			| translate : { responseTime: responseTime }
			}}
			{{ "success.dropEmail" | translate }}
			<a href="mailto:info@policystreet.com">info&#64;policystreet.com</a>.
		</span>
		<span *ngIf="!onOperation">
			{{ "success.getBack" | translate }} {{ "success.dropEmail" | translate }}
			<a href="mailto:info@policystreet.com">info&#64;policystreet.com</a>.
		</span>


		<ng-container *ngIf="redirect; else default">
			<button style="background: #FFD100;" mat-flat-button mat-primary mat-dialog-close (click)="onClose()">
				{{ "success.close" | translate }}
			</button>
		</ng-container>
		<ng-template #default>
			<button style="background: #FFD100;" mat-flat-button mat-primary mat-dialog-close>
				{{ "success.close" | translate }}
			</button> 
		</ng-template>
	</div>
</div>